import { render, staticRenderFns } from "./MenuNetworkPermissions.vue?vue&type=template&id=6d37d02c"
import script from "./MenuNetworkPermissions.vue?vue&type=script&lang=js"
export * from "./MenuNetworkPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports